import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';
import { channelLayoutValues } from 'default-settings';

import { getAllSettings } from 'shared/selectors/app-settings';

import updateAppSettings from 'widget/redux/client/actions/app-settings/update';


const MAX_WIDGET_WIDTH = 980;


@connect(state => ({
  // lazyVideoLists is needed to trigger height calculations
  // TODO: move resizing logic to view
  lazyVideoLists: state.lazyVideoLists,
  appSettings: getAllSettings(state),
}), {
  updateAppSettings,
})
export default class UpdateWidgetSize extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    lazyVideoLists: React.PropTypes.object,
    disabled: React.PropTypes.bool,
    updateAppSettings: React.PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    this.updateWidgetSize();
    window.addEventListener('resize', this.updateWidgetSize);
  }

  shouldComponentUpdate(nextProps) {
    return !_.isEqual(this.props.lazyVideoLists, nextProps.lazyVideoLists);
  }

  componentDidUpdate() {
    this.updateWidgetSize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidgetSize);
  }

  @autobind
  @debounce
  updateWidgetSize() {
    if (this.props.disabled) {
      return;
    }

    const { appSettings, updateAppSettings } = this.props;
    const requestedWidgetSize = _.get(appSettings, 'requestedWidgetSize');
    const layout = _.get(appSettings, 'numbers.channelLayout');
    const widgetSize = {
      width: layout === channelLayoutValues.STRIP ? window.innerWidth : Math.min(window.innerWidth, MAX_WIDGET_WIDTH),
      height: window.innerHeight,
    };

    if (_.isEqual(requestedWidgetSize, widgetSize)) {
      return;
    }

    // TODO: change to updateUI
    updateAppSettings({
      requestedWidgetSize: widgetSize,
    });
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/update-widget-size.js